import { useQuery } from "@tanstack/react-query";
import { getTransaction } from "../api";

export const useGetTransaction = (filter?: {
  startDate?: string;
  endDate?: string;
}) => {
  const cleanedFilter = Object.fromEntries(
    Object.entries(filter || {}).filter(
      ([_, value]) => value !== undefined && value !== null && value !== ""
    )
  );

  const { data, isLoading } = useQuery({
    queryKey: ["TRANSACTION", cleanedFilter],
    queryFn: () => getTransaction(cleanedFilter),
    select: ({ data }) => data,
  });

  return { transaction: data, isLoading };
};
